import { paydirtConfig } from '@/config/paydirt';

/** Primary site navigation — shared by sidebar and footer. */
export const EXPLORE_NAV = [
  { href: '/', label: 'Home', icon: 'uil-home' },
  {
    href: paydirtConfig.haulReports.path,
    label: paydirtConfig.haulReports.label,
    icon: 'uil-compass',
    hint: paydirtConfig.haulReports.description,
  },
  {
    href: paydirtConfig.leaderboard.path,
    label: paydirtConfig.leaderboard.label,
    icon: 'uil-trophy',
    hint: paydirtConfig.leaderboard.description,
  },
  { href: '/materials/', label: 'Price guide', icon: 'uil-tag-alt', hint: 'Community gem and mineral reference prices' },
  {
    href: paydirtConfig.forum.path,
    label: paydirtConfig.forum.label,
    icon: 'uil-comments',
    hint: paydirtConfig.forum.description,
  },
  {
    href: paydirtConfig.groups.path,
    label: paydirtConfig.groups.label,
    icon: 'uil-users-alt',
    hint: paydirtConfig.groups.description,
  },
  {
    href: paydirtConfig.calendar.path,
    label: paydirtConfig.calendar.label,
    icon: 'uil-calendar',
    hint: paydirtConfig.calendar.description,
  },
  {
    href: paydirtConfig.blog.path,
    label: paydirtConfig.blog.label,
    icon: 'uil-document-layout-left',
    hint: paydirtConfig.blog.description,
  },
  { href: paydirtConfig.feedback.path, label: 'Feedback', icon: 'uil-comment-alt', hint: paydirtConfig.feedback.description },
] as const;

/** Sidebar links above the marketplace section. */
export const SIDEBAR_NAV_MAIN = EXPLORE_NAV.filter(
  (item) => item.href !== '/materials/' && item.href !== paydirtConfig.feedback.path,
);

/** Sidebar links below the marketplace section. */
export const SIDEBAR_NAV_AFTER_MARKETPLACE = EXPLORE_NAV.filter(
  (item) => item.href === '/materials/' || item.href === paydirtConfig.feedback.path,
);

export const ACCOUNT_NAV = [
  { href: '/settings/account/', label: 'Settings', icon: 'uil-setting' },
  { href: '/settings/notifications/', label: 'Notifications', icon: 'uil-bell' },
] as const;

/** Sidebar explore links only — account/settings live in the header avatar menu. */
export const SIDEBAR_NAV = [...SIDEBAR_NAV_MAIN, ...SIDEBAR_NAV_AFTER_MARKETPLACE] as const;

export function isNavActive(pathname: string, href: string): boolean {
  if (href === '/') return pathname === '/' || pathname === '';
  return pathname.startsWith(href.replace(/\/$/, ''));
}

/** True on price guide index and material detail pages. */
export function isPriceGuideRoute(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/materials' || path.startsWith('/materials/');
}

/** Display name for a forum topic slug in the UI. */
export function forumTopicLabel(subSlug: string): string {
  if (subSlug === paydirtConfig.forum.defaultSubSlug) {
    return paydirtConfig.forum.label;
  }
  return subSlug;
}

export function forumTopicDescription(subSlug: string): string | undefined {
  if (subSlug === paydirtConfig.forum.defaultSubSlug) {
    return paydirtConfig.forum.description;
  }
  return undefined;
}
